/* eslint-disable no-unused-vars */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import close from '../../assets/close3.svg'
import { useNavigate } from "react-router-dom";
import down from '../../assets/down.svg'
import qrcode from '../../assets/qrcode.png'
import foto1 from '../../assets/foto4.png'
import { CSSTransition } from 'react-transition-group';
import { MobileNavbar } from '../NavBar/Mobile/MobileNavbar';
import spinner from '../../assets/spinner.gif'
import { MBPcard } from '../Card/MBPcard/MBPcard';

export const PageMyBooking = () => {

    const [detail, setDetail] = useState()
    const [loading, setLoading] = useState(true)
    const [section, setSection] = useState(1)
    const [showQR, setShowQR] = useState(false)
    const [showHelp, setShowHelp] = useState(false)
    const [qr, setqr] = useState()
    const [chefname, setchefname] = useState()
    const [subject, setSubject] = useState('Select Subject')
    const [showSubject, setShowSubject] = useState(false)
    const [details, setDetails] = useState('')
    const [ordernumber, setordernumber] = useState('')
    const [showRateUs, setShowRateUs] = useState(false)
    const [rate1, setrate1] = useState()
    const [rate2, setrate2] = useState()
    const [rate3, setrate3] = useState()
    const [rate4, setrate4] = useState()
    const [rate5, setrate5] = useState()
    const [rate6, setrate6] = useState()
    const [rate7, setrate7] = useState()
    const [review, setReview] = useState('')
    const [showOpsi, setShowOpsi] = useState()
    const [showNavPopup, setShowNavPopup] = useState(false)

    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        setDetail([{ordernumber:1,qr:qrcode,done:false,nama:"Zidane Dane",bookingCode:"aezakmi1",status:"In Review",prefix:"+62",phoneNumber:"85673869402",namaChef:"Fauzan Pradana", foto:foto1,Type:"Asian",tanggal:"24-02-2022", total:"200000",address:"Apartement kuningan place, Jl. H Kavling No.15, RW.1, Menteng Atas, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12980"},{ordernumber:2,qr:qrcode,done:false,nama:"Zidane Dane",bookingCode:"aezakmi2",status:"Approve",prefix:"+62",phoneNumber:"85673869402",namaChef:"Fauzan Pradana", foto:foto1,Type:"Asian",tanggal:"24-02-2022", total:"200000",address:"Apartement kuningan place, Jl. H Kavling No.15, RW.1, Menteng Atas, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12980"},{ordernumber:3,qr:qrcode,done:false,nama:"Zidane Dane",bookingCode:"aezakmi3",status:"Rejected",prefix:"+62",phoneNumber:"85673869402",namaChef:"Fauzan Pradana", foto:foto1,Type:"Asian",tanggal:"24-02-2022", total:"200000",address:"Apartement kuningan place, Jl. H Kavling No.15, RW.1, Menteng Atas, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12980"},{ordernumber:4,qr:qrcode,done:false,nama:"Zidane Dane",bookingCode:"aezakmi3",status:"Success",prefix:"+62",phoneNumber:"85673869402",namaChef:"Fauzan Pradana", foto:foto1,Type:"Asian",tanggal:"24-02-2022", total:"200000",address:"Apartement kuningan place, Jl. H Kavling No.15, RW.1, Menteng Atas, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12980"},{ordernumber:5,qr:qrcode,done:true,nama:"Zidane Dane",bookingCode:"aezakmi3",status:"Success",prefix:"+62",phoneNumber:"85673869402",namaChef:"Fauzan Pradana", foto:foto1,Type:"Asian",tanggal:"24-02-2022", total:"200000",address:"Apartement kuningan place, Jl. H Kavling No.15, RW.1, Menteng Atas, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12980"}])
        localStorage.setItem('nav', 'mb')
    },[])
    const [standby, setstandby] = useState(true)
    const firstUpdate = useRef(true);
    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            setLoading(false)
        }
    },[detail])
    const history = useNavigate()

    const handleRateUs = (e) => {
        console.log("terpanggil")
        console.log(e)
        setShowRateUs(true)
        setordernumber(e)
        setrate1()
        setrate2()
        setrate3()
        setrate4()
        setrate5()
        setrate6()
        setrate7()
        setReview('')
    }

    const handleChooseSubject = () => {
        var elem = document.getElementById("MBPdown");
        var elem2 = document.getElementById("MBPsubject");
        elem.style.transition = "transform 0.5s"
        var defaultclassname = elem2.className
        if(showSubject){
            setShowSubject(false)
            elem.style.transform = "rotate(0deg)"
            elem2.className = defaultclassname.replace("MBPyellow","")
            
        }else{
            setShowSubject(true)
            elem.style.transform = "rotate(180deg)"
            elem2.className = defaultclassname + " MBPyellow"
        }
    }

    const handleSelectSubject = (e) => {
        var elem = document.getElementById("MBPsubject");
        setSubject(e)
        elem.className = "flex black tiny MBPsubject MBPmargin3"
    }

    const handleQRchef = (e) => {
        setShowQR(true)
        setchefname(e[0])
        setqr(e[1])
    }

    const handleHelp = (e) => {
        setShowHelp(true)
        setShowSubject(false)
        setDetails('')
        setSubject('Select Subject')
        var elem = document.getElementById("MBPsubject");
        elem.className = "flex grey verytiny MBPsubject MBPmargin3"
        console.log(e)
    }

    useEffect(()=>{
        
        if(standby===false){
            setTimeout(function() {
           }, 500);
        }
    },[standby])

    const handleCloseAll = () => {
        setShowOpsi()
        setShowNavPopup(false)
    }

    
    
    return (
        <div  onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <MobileNavbar></MobileNavbar>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="MBPtrans">
                <div>
                    <div className='MBPkontainer'>
                        <div className='MBPheader flex'>
                            <p className='white big bold MBPtittle'>Your Bookings</p>
                            {
                                section===1?
                            <div className="MBPheadernav flex">
                                <p onClick={()=>setSection(1)} className='medium white MBPunderline' style={{marginRight:"10px", cursor:"pointer"}}>Active Booking</p>
                                <p onClick={()=>setSection(2)} className='medium white' style={{marginLeft:"20px",marginRight:"20px",cursor:"pointer"}}>Booking History</p>
                            </div>
                            :
                            <div className="MBPheadernav flex">
                                <p onClick={()=>setSection(1)} className='medium white' style={{marginRight:"10px", cursor:"pointer"}}>Active Booking</p>
                                <p onClick={()=>setSection(2)} className='medium white MBPunderline' style={{marginLeft:"20px",marginRight:"20px",cursor:"pointer"}}>Booking History</p>
                            </div>
                            }
                        </div>
                        {detail.map((post,i) => (
                            <MBPcard number={i+1} showOpsi={showOpsi} setShowOpsi={e => setShowOpsi(e)} post={post} fungsi={e => handleQRchef(e)} fungsi2={e => handleHelp(e)} fungsi3={e => handleRateUs(e)} />
                        ))}
                        
                    </div>
                    
                    {showQR && (
                        <div className='MBPqrwrapper'>
                            <div onClick={() => setShowQR(false)} className='MBPqrouter'/>
                            <div className='MBPqrkonten'>
                                <p className='semibig' style={{textAlign:"center"}}>QR For Chef</p>
                                <img alt="qr" className='MBPqrimg' src={qr}></img>
                                <p className='small bold MBPqrchefname'>Chef {chefname}</p>
                                <img onClick={() => setShowQR(false)} alt='icon' className='MBPiconqr' src={close}></img>
                            </div>
                        </div>
                    )}

                    {showRateUs && (
                        <div className='MBPqrwrapper'>
                            <div onClick={() => setShowRateUs(false)} className='MBPqrouter'/>
                            <div className='MBPqrkonten'>
                                <p className='semibig' style={{textAlign:"center"}}>Rate Us</p>
                                <p className='small MBPmargin2 flex'>Order Number: <span style={{marginLeft:"auto"}}>{ordernumber}</span></p>
                                <div className='ratingwrapper MBPmargin2'>
                                <p className='medium'>Rate your booking experience with Taplak</p>
                                
                                <div className="rating">
                                    <input type="radio" name="rating" value="5" id="5" onChange={e => setrate1(e.target.value)}/><label for="5">☆</label>
                                    <input type="radio" name="rating" value="4" id="4" onChange={e => setrate1(e.target.value)}/><label for="4">☆</label>
                                    <input type="radio" name="rating" value="3" id="3" onChange={e => setrate1(e.target.value)}/><label for="3">☆</label>
                                    <input type="radio" name="rating" value="2" id="2" onChange={e => setrate1(e.target.value)}/><label for="2">☆</label>
                                    <input type="radio" name="rating" value="1" id="1" onChange={e => setrate1(e.target.value)}/><label for="1">☆</label>
                                </div>
                                <p className='medium MBPmargin2'>How do you rate the chef/private dining brand/beverage specialist</p>
                                <div className="rating">
                                    <input type="radio" name="rating2" value="5" id="52" onChange={e => setrate2(e.target.value)}/><label for="52">☆</label>
                                    <input type="radio" name="rating2" value="4" id="42" onChange={e => setrate2(e.target.value)}/><label for="42">☆</label>
                                    <input type="radio" name="rating2" value="3" id="32" onChange={e => setrate2(e.target.value)}/><label for="32">☆</label>
                                    <input type="radio" name="rating2" value="2" id="22" onChange={e => setrate2(e.target.value)}/><label for="22">☆</label>
                                    <input type="radio" name="rating2" value="1" id="12" onChange={e => setrate2(e.target.value)}/><label for="12">☆</label>
                                </div>
                                <p className='medium MBPmargin2'>How do you rate the Set Menu</p>
                                <div className="rating">
                                    <input type="radio" name="rating3" value="5" id="53" onChange={e => setrate3(e.target.value)}/><label for="53">☆</label>
                                    <input type="radio" name="rating3" value="4" id="43" onChange={e => setrate3(e.target.value)}/><label for="43">☆</label>
                                    <input type="radio" name="rating3" value="3" id="33" onChange={e => setrate3(e.target.value)}/><label for="33">☆</label>
                                    <input type="radio" name="rating3" value="2" id="23" onChange={e => setrate3(e.target.value)}/><label for="23">☆</label>
                                    <input type="radio" name="rating3" value="1" id="13" onChange={e => setrate3(e.target.value)}/><label for="13">☆</label>
                                </div>
                                <p className='medium MBPmargin2'>How do you rate the Price</p>
                                <div className="rating">
                                    <input type="radio" name="rating4" value="5" id="54" onChange={e => setrate4(e.target.value)}/><label for="54">☆</label>
                                    <input type="radio" name="rating4" value="4" id="44" onChange={e => setrate4(e.target.value)}/><label for="44">☆</label>
                                    <input type="radio" name="rating4" value="3" id="34" onChange={e => setrate4(e.target.value)}/><label for="34">☆</label>
                                    <input type="radio" name="rating4" value="2" id="24" onChange={e => setrate4(e.target.value)}/><label for="24">☆</label>
                                    <input type="radio" name="rating4" value="1" id="14" onChange={e => setrate4(e.target.value)}/><label for="14">☆</label>
                                </div>
                                <p className='medium MBPmargin2'>How do you rate the Set Menu</p>
                                <div className="rating">
                                    <input type="radio" name="rating5" value="5" id="55" onChange={e => setrate4(e.target.value)}/><label for="55">☆</label>
                                    <input type="radio" name="rating5" value="4" id="45" onChange={e => setrate4(e.target.value)}/><label for="45">☆</label>
                                    <input type="radio" name="rating5" value="3" id="35" onChange={e => setrate4(e.target.value)}/><label for="35">☆</label>
                                    <input type="radio" name="rating5" value="2" id="25" onChange={e => setrate4(e.target.value)}/><label for="25">☆</label>
                                    <input type="radio" name="rating5" value="1" id="15" onChange={e => setrate4(e.target.value)}/><label for="15">☆</label>
                                </div>
                                <p className='medium MBPmargin2'>How do you rate the Price</p>
                                <div className="rating">
                                    <input type="radio" name="rating6" value="5" id="56" onChange={e => setrate4(e.target.value)}/><label for="56">☆</label>
                                    <input type="radio" name="rating6" value="4" id="46" onChange={e => setrate4(e.target.value)}/><label for="46">☆</label>
                                    <input type="radio" name="rating6" value="3" id="36" onChange={e => setrate4(e.target.value)}/><label for="36">☆</label>
                                    <input type="radio" name="rating6" value="2" id="26" onChange={e => setrate4(e.target.value)}/><label for="26">☆</label>
                                    <input type="radio" name="rating6" value="1" id="16" onChange={e => setrate4(e.target.value)}/><label for="16">☆</label>
                                </div>
                                <p className='medium MBPmargin2'>How do you rate the Private dining experience</p>
                                <div className="rating">
                                    <input type="radio" name="rating7" value="5" id="57" onChange={e => setrate4(e.target.value)}/><label for="57">☆</label>
                                    <input type="radio" name="rating7" value="4" id="47" onChange={e => setrate4(e.target.value)}/><label for="47">☆</label>
                                    <input type="radio" name="rating7" value="3" id="37" onChange={e => setrate4(e.target.value)}/><label for="37">☆</label>
                                    <input type="radio" name="rating7" value="2" id="27" onChange={e => setrate4(e.target.value)}/><label for="27">☆</label>
                                    <input type="radio" name="rating7" value="1" id="17" onChange={e => setrate4(e.target.value)}/><label for="17">☆</label>
                                </div>
                                <p className='medium MBPmargin2'>Review</p>
                                <textarea style={{marginRight:"8px"}} id="MBPenterAddress" type='text' className='MBPform tiny MBPmargin3' rows="5"  value={review} onChange={e => setReview(e.target.value)} placeholder="Text here for the review"></textarea>
                                </div>
                                <button onClick={() => setShowRateUs(false)} className='MBPbuttonpopup MBPmargin2 small bold'>Submit</button>
                                

                                <img onClick={() => setShowRateUs(false)} alt='icon' className='MBPiconqr' src={close}></img>
                            </div>
                        </div>
                    )}

                    {showHelp && (
                        <div className='MBPqrwrapper'>
                            <div onClick={() => setShowHelp(false)} className='MBPqrouter'/>
                            <div className='MBPqrkonten'>
                                <p className='semibig' style={{textAlign:"center"}}>Ask For Help</p>
                                <img onClick={() => setShowHelp(false)} alt='icon' className='MBPiconqr' src={close}></img>
                                <p className='medium MBPmargin2'>Subject</p>
                                <div id='MBPsubject' onClick={() => handleChooseSubject()} className='flex grey verytiny MBPsubject MBPmargin3'>
                                    <p>{subject}</p>
                                    <img id="MBPdown" alt='icon' className='MBPicon' style={{marginLeft:"auto"}} src={down}></img>
                                    {
                                        showSubject && (
                                            <div className='MBPsubjectchoice'>
                                                <p onClick={() => handleSelectSubject('Cancellation')} className='tiny black' style={{marginBottom:"16px", cursor:"pointer"}}>Cancellation</p>
                                                <p onClick={() => handleSelectSubject('Change Date')} className='tiny black' style={{marginBottom:"16px", cursor:"pointer"}}>Change Date</p>
                                                <p onClick={() => handleSelectSubject('Change Venue')} className='tiny black' style={{marginBottom:"16px", cursor:"pointer"}}>Change Venue</p>
                                                <p onClick={() => handleSelectSubject('Change Pax')} className='tiny black' style={{marginBottom:"16px", cursor:"pointer"}}>Change Pax</p>
                                                <p onClick={() => handleSelectSubject('Aditional information')} className='tiny black' style={{marginBottom:"16px", cursor:"pointer"}}>Aditional information</p>
                                                <p onClick={() => handleSelectSubject('Other')} style={{cursor:"pointer"}} className='tiny black'>Other</p>
                                            </div>
                                        )
                                    }
                                </div>
                                <p className='medium MBPmargin2'>Details</p>
                                <textarea id="MBPenterAddress" type='text' className='MBPform tiny MBPmargin2' rows="5"  value={details} onChange={e => setDetails(e.target.value)} placeholder="Text here for the detail"></textarea>
                            </div>
                        </div>
                    )}  

                </div>
                </CSSTransition>
            }
        </div>
    )
  }